BrowseErrorPresenter = require '../presenters/error'
BrowseErrorMessageTemplate = require '../../error_message.html.mustache'

module.exports = BrowseErrorHtml = ->
  presenter = new BrowseErrorPresenter
  hash = presenter.toHash()
  BrowseErrorMessageTemplate.render hash
